export const TIKTOK_IMAGE_SIZE_SPEC = {
  width: 385,
  height: 684,
  pictureWidth: 385,
  minHeight: 680,
  maxHeight: 680
};

export const companyNameStyle = {
  textAlign: "left",
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff"
};

export const teaserTextStyle = {
  fontSize: "12px",
  lineHeight: 1.3,
  color: "#fff",
  textAlign: "left"
};
